import { CreatePetModal } from '$features/pets/pages/create'
import { PetPage } from '$features/pets/pages/pet'
import { AppointmentHistoryTab } from '$features/pets/pages/pet/tabs/appointment-history'
import { PetDetailsTab } from '$features/pets/pages/pet/tabs/details'
// import { GalleryTab } from '$features/pets/pages/pet/tabs/gallery'
import { MedicalInformationTab } from '$features/pets/pages/pet/tabs/medical-information'
import { NotesTab } from '$features/pets/pages/pet/tabs/notes'
import { PetsPage } from '$features/pets/pages/pets'
import { EditPetProfileModal } from '$features/pets/pages/edit-pet-profile'
import { EditPetInformationModal } from '$features/pets/pages/edit-pet-information'
import { EditParentInformationModal } from '$features/pets/pages/edit-parent-information'
import { EditMedicalDetailsModal } from '$features/pets/pages/edit-medical-information'
import { EditVeterinaryInformationModal } from '$features/pets/pages/edit-veterinary-information'
import { EditMedicalNotesModal } from '$features/pets/pages/edit-medical-notes'
import { EditNotesModal } from '$features/pets/pages/edit-notes'
import { CreatePetAppointmentModal } from '$features/pets/pages/create-appointment'
import { Navigate, RouteObject } from 'react-router-dom'

export enum PetRoutePaths {
  Pets = '/pets',
  PetsCreate = '/pets/create',
  PetsView = '/pets/:id',
  PetsNameEdit = 'edit-name',
  PetsInformationEdit = 'edit-information',
  PetsParentEdit = 'edit-parent',
  PetsMedicalDetailsEdit = 'edit-medical-details',
  PetsVeterinaryInformationEdit = 'edit-veterinary-information',
  PetsMedicalNotesEdit = 'edit-medical-notes',
  PetsNotesEdit = 'edit-notes',
  PetsCreateAppointment = 'create-appointment',

  // Pets View Tabs
  PetsDetails = 'details',
  PetsAppointmentHistory = 'appointment-history',
  PetsMedicalInformation = 'medical-information',
  PetsNotes = 'notes',
  PetsGallery = 'gallery',
}

const createAppointmentRoute = {
  path: PetRoutePaths.PetsCreateAppointment,
  element: <CreatePetAppointmentModal />,
}

export const protectedPetRoutes: RouteObject[] = [
  {
    path: PetRoutePaths.Pets,
    element: <PetsPage />,
    children: [
      {
        path: PetRoutePaths.PetsCreate,
        element: <CreatePetModal />,
      },
    ],
  },
  {
    path: PetRoutePaths.PetsView,
    element: <PetPage />,
    children: [
      {
        index: true,
        element: <Navigate
          to={PetRoutePaths.PetsDetails}
          replace
        />,
      },
      {
        path: PetRoutePaths.PetsDetails,
        element: <PetDetailsTab />,
        children: [
          {
            path: PetRoutePaths.PetsNameEdit,
            element: <EditPetProfileModal />,
          },
          {
            path: PetRoutePaths.PetsInformationEdit,
            element: <EditPetInformationModal />,
          },
          {
            path: PetRoutePaths.PetsParentEdit,
            element: <EditParentInformationModal />,
          },
          createAppointmentRoute,
        ],
      },
      {
        path: PetRoutePaths.PetsAppointmentHistory,
        element: <AppointmentHistoryTab />,
        children: [
          {
            path: PetRoutePaths.PetsNameEdit,
            element: <EditPetProfileModal />,
          },
          createAppointmentRoute,
        ],
      },
      {
        path: PetRoutePaths.PetsMedicalInformation,
        element: <MedicalInformationTab />,
        children: [
          {
            path: PetRoutePaths.PetsNameEdit,
            element: <EditPetProfileModal />,
          },
          {
            path: PetRoutePaths.PetsMedicalDetailsEdit,
            element: <EditMedicalDetailsModal />,
          },
          {
            path: PetRoutePaths.PetsVeterinaryInformationEdit,
            element: <EditVeterinaryInformationModal />,
          },
          {
            path: PetRoutePaths.PetsMedicalNotesEdit,
            element: <EditMedicalNotesModal />,
          },
          createAppointmentRoute,
        ],
      },
      {
        path: PetRoutePaths.PetsNotes,
        element: <NotesTab />,
        children: [
          {
            path: PetRoutePaths.PetsNameEdit,
            element: <EditPetProfileModal />,
          },
          {
            path: PetRoutePaths.PetsNotesEdit,
            element: <EditNotesModal />,
          },
          createAppointmentRoute,
        ],
      },
      // {
      //   path: PetRoutePaths.PetsGallery,
      //   element: <GalleryTab />,
      //   children: [
      //     {
      //       path: PetRoutePaths.PetsNameEdit,
      //       element: <EditPetProfileModal />,
      //     },
      //   ],
      // },
    ],
  },
]
